<script setup lang="ts">
import type { AccordionContentProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { AccordionContent } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<
	AccordionContentProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<AccordionContent
		v-bind="delegatedProps"
		class="overflow-hidden text-sm transition-all duration-200 ease-out data-[state=closed]:[animation:accordion-up_0.2s_ease-out] data-[state=open]:[animation:accordion-down_0.2s_ease-out]"
	>
		<div :class="cn('pb-4 pt-0', props.class)">
			<slot />
		</div>
	</AccordionContent>
</template>
